import { inject, Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ErrorModalComponent } from '../../shared/components/error-modal/error-modal.component';
import { ConfirmModalComponent } from '../../shared/components/confirm-modal/confirm-modal.component';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({
    providedIn: 'root',
})
export class CommonModalUtils {

    private readonly ngbModal = inject(NgbModal);
    private readonly translocoService = inject(TranslocoService);

    public showErrorModal(message: string): Promise<any> {
        this.ngbModal.dismissAll();
        const modalRef = this.ngbModal.open(ErrorModalComponent);
        modalRef.componentInstance.message = message;
        return modalRef.result;
    }

    public showConfirmModal(title: string, message: string, showCancel: boolean = true) {
        this.ngbModal.dismissAll();
        const modalRef = this.ngbModal.open(ConfirmModalComponent);
        modalRef.componentInstance.title = title;
        modalRef.componentInstance.message = message;
        modalRef.componentInstance.showCancel = showCancel;
        return modalRef.result;
    }
}
